import React, { useMemo, useRef, useState } from "react";
import { motion } from "framer-motion";

import {
  copyIcon,
  exportIcon,
  filterIcon,
  searchIcon,
} from "../../../Base/SVG";
import Dropdown from "../../../Base/Dropdown";
import { TableModul } from "./TableModul";
import { Pagination } from "./Pagination";

export default function InvoiceTable({ setModal, setModalData }) {
  const [activeList, setActiveList] = useState(TableModul);
  const [currentPage, setCurrentPage] = useState(1);
  let PageSize = 6;

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return activeList.slice(firstPageIndex, lastPageIndex);
  }, [currentPage]);

  return (
    <div className="invoiceTable box">
      <div className="invoiceTable__header">
        <div className="search">
          <input type="text" placeholder="Search for transaction here" />
          <button className="button" type="button">
            {searchIcon}
          </button>
        </div>
        <div className="invoiceTable__header-action">
          <Dropdown btnInner={<>{filterIcon} Filter</>}>
            <div className="dropdown__menu-link">filter 1</div>
            <div className="dropdown__menu-link">filter 2</div>
          </Dropdown>
          <button type="button" className="button export">
            {exportIcon} Export
          </button>
        </div>
      </div>
      <div className="invoiceTable__body">
        <table>
          <thead>
            <tr>
              <th>Amount</th>
              <th>Token</th>
              <th>Network</th>
              <th>Creation Date</th>
              <th>Payment Date</th>
              <th>Status</th>
              <th>NFT Link</th>
              <th>Tx Link</th>
              <th>Invoice Link</th>
            </tr>
          </thead>
          <tbody>
            {currentTableData.map((item, index) => {
              return (
                <TableRow
                  key={index}
                  {...item}
                  onClick={() => {
                    setModal("details");
                    setModalData(item);
                  }}
                />
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="invoiceTable__footer">
        <Pagination
          currentPage={currentPage}
          totalCount={activeList.length}
          pageSize={PageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </div>
  );
}
const TableRow = (props) => {
  const [copied, setCopied] = useState(null);
  const refBtn1 = useRef(null);
  const refBtn2 = useRef(null);
  const refBtn3 = useRef(null);
  const clickFunc = (e) => {
    if (
      !refBtn1.current.contains(e.target) &&
      !refBtn2.current.contains(e.target) &&
      !refBtn3.current.contains(e.target)
    )
      props.onClick();
  };
  const copyBtn = (data, id, type) => {
    navigator.clipboard.writeText(data);
    setCopied({ id: id, type: type });
    setTimeout(() => {
      setCopied(null);
    }, 1000);
  };

  return (
    <motion.tr
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
      exit={{ opacity: 0 }}
      onClick={clickFunc}
    >
      <td>{props.amount}</td>
      <td>
        <div className="invoiceTable__row">
          <img src={process.env.PUBLIC_URL + props.tokenIcon} alt="token" />
          {props.token}
        </div>
      </td>
      <td>
        <div className="invoiceTable__row">
          <img src={process.env.PUBLIC_URL + props.networkIcon} alt="token" />
          {props.network}
        </div>
      </td>
      <td>{props.creationDate}</td>
      <td>{props.paymentDate}</td>
      <td>
        {props.status === "paid" && (
          <div className="status active">{props.status}</div>
        )}
        {props.status === "expired" && (
          <div className="status inActive">{props.status}</div>
        )}
        {props.status === "requested" && (
          <div className="status hold">{props.status}</div>
        )}
      </td>
      <td>
        <div
          className="link"
          ref={refBtn1}
          onClick={() => copyBtn(props.nftLink, props.id, "nftLink")}
        >
          NFT Link
          {copyIcon}
          <span
            className={
              "tooltip " +
              (copied?.id === props.id && copied?.type === "nftLink"
                ? "active"
                : "")
            }
          >
            Copied
          </span>
        </div>
      </td>
      <td>
        <div
          className="link"
          ref={refBtn2}
          onClick={() => copyBtn(props.txLink, props.id, "txLink")}
        >
          {props.txLink}
          {copyIcon}
          <span
            className={
              "tooltip " +
              (copied?.id === props.id && copied?.type === "txLink"
                ? "active"
                : "")
            }
          >
            Copied
          </span>
        </div>
      </td>
      <td>
        <div
          className="link"
          ref={refBtn3}
          onClick={() => copyBtn(props.invoiceLink, props.id, "invoiceLink")}
        >
          {props.invoiceLink}
          {copyIcon}
          <span
            className={
              "tooltip " +
              (copied?.id === props.id && copied?.type === "invoiceLink"
                ? "active"
                : "")
            }
          >
            Copied
          </span>
        </div>
      </td>
    </motion.tr>
  );
};
// {currentTableData.map((item, index) => {
//   return (
//     <NoticeItem
//       key={index}
//       {...item}
//       onClick={() => {
//         setTab("detail");
//         setItemIndex(index);
//       }}
//     />
//   );
// })}
// </div>
